import React, { useState, useEffect } from 'react';
import { categoryService } from '../api/categoryService';
import Table from '../components/Common/Table';
import Modal from '../components/Common/Modal';
import Pagination from '../components/Common/Pagination';
import SearchBar from '../components/Common/SearchBar';
import CategoryForm from '../components/Categories/CategoryForm';
import '../components/Common/Common.css';

function Categories() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [editingCategory, setEditingCategory] = useState(null);

  const fetchCategories = async () => {
    try {
      setLoading(true);
      const response = await categoryService.getCategories({
        page: currentPage,
        search: searchTerm,
        per_page: 15,
      });
      setCategories(response.data);
      setLastPage(response.last_page || 1);
    } catch (error) {
      console.error('Error fetching categories:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, [currentPage, searchTerm]);

  const handleDelete = async (id) => {
    if (window.confirm('Êtes-vous sûr de vouloir supprimer cette catégorie?')) {
      try {
        await categoryService.deleteCategory(id);
        fetchCategories();
      } catch (error) {
        console.error('Error deleting category:', error);
        alert('Échec de la suppression de la catégorie');
      }
    }
  };

  const handleEdit = (category) => {
    setEditingCategory(category);
    setShowModal(true);
  };

  const handleCreate = () => {
    setEditingCategory(null);
    setShowModal(true);
  };

  const handleFormSuccess = () => {
    setShowModal(false);
    setEditingCategory(null);
    fetchCategories();
  };

  const columns = [
    { key: 'id', label: 'ID' },
    { key: 'name', label: 'Nom' },
    { key: 'slug', label: 'Slug' },
    {
      key: 'parent_id',
      label: 'Catégorie parente',
      render: (val, row) => row.parent?.name || 'Aucune'
    },
    { key: 'display_order', label: 'Ordre' },
  ];

  return (
    <div>
      <div className="page-header">
        <h1>Catégories</h1>
        <button onClick={handleCreate} className="btn btn-primary">
          Ajouter une catégorie
        </button>
      </div>

      <div className="filters">
        <div className="filters-grid">
          <div style={{ gridColumn: 'span 2' }}>
            <SearchBar
              value={searchTerm}
              onChange={setSearchTerm}
              placeholder="Rechercher des catégories par nom ou description..."
              onClear={() => setCurrentPage(1)}
            />
          </div>
        </div>
      </div>

      <Table
        columns={columns}
        data={categories}
        loading={loading}
        onEdit={handleEdit}
        onDelete={handleDelete}
      />

      <Pagination
        currentPage={currentPage}
        lastPage={lastPage}
        onPageChange={setCurrentPage}
      />

      <Modal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        title={editingCategory ? 'Modifier la catégorie' : 'Ajouter une catégorie'}
      >
        <CategoryForm
          category={editingCategory}
          onSuccess={handleFormSuccess}
          onCancel={() => setShowModal(false)}
        />
      </Modal>
    </div>
  );
}

export default Categories;
